import { createFileRoute } from '@tanstack/react-router'
import { AwardRatesSettings } from '@/features/organizations/settings/award-rates'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/award-rates'
)({
  component: AwardRatesSettings,
})
